import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

const ApplyJob: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    position: "",
    about: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <>
    <Header />
     
    <section
      style={{
        background: "#f8f8f8",
        padding: "100px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "850px",
          margin: "0 auto",
        }}
      >
        {/* Breadcrumb */}
        <div className="mil-breadcrumbs">
  <a href="/">Home</a>
  <span> / </span>
  <a href="/careers">Careers</a>
  <span> / </span>
  <span>Apply for Job</span>
</div>

        {/* Title */}
        <h1
          style={{
            textAlign: "center",
            fontSize: "52px",
            fontWeight: 700,
            marginBottom: "50px",
          }}
        >
          Apply for job
        </h1>

        {/* Upload Resume */}
        
<div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    marginBottom: "50px",
  }}
>
  <label
    htmlFor="resume"
    style={{
     cursor: "pointer",
      fontSize: "12px",
      color: "#666",
      margin: 0,
    }}
  >
    Upload Resume
  </label>

  <label
    htmlFor="resume"
    style={{
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      background: "#d9d9d9",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "10px",
      color: "#000",
    }}
  >
    ↓
  </label>

  <input
    id="resume"
    type="file"
    style={{ display: "none" }}
  />
</div>

        <form onSubmit={handleSubmit}>
          {/* Row 1 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              marginBottom: "30px",
            }}
          >
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="job-input"
            />

            <input
              type="email"
              name="email"
              placeholder="Email ID"
              value={formData.email}
              onChange={handleChange}
              className="job-input"
            />
          </div>

          {/* Row 2 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              marginBottom: "30px",
            }}
          >
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              className="job-input"
            />

            <input
              type="text"
              name="city"
              placeholder="Current City"
              value={formData.city}
              onChange={handleChange}
              className="job-input"
            />
          </div>

          {/* Row 3 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              marginBottom: "30px",
            }}
          >
            <input
              type="file"
              className="job-input"
            />

            <select
              name="position"
              value={formData.position}
              onChange={handleChange}
              className="job-input"
            >
              <option value="">Position to apply for</option>
              <option>Graphic Designer</option>
              <option>Web Developer</option>
              <option>UI/UX Designer</option>
              <option>Marketing Executive</option>
            </select>
          </div>

          {/* About Yourself */}
          <textarea
            name="about"
            placeholder="Tell us about yourself as descriptively as possible"
            value={formData.about}
            onChange={handleChange}
            rows={6}
            className="job-textarea"
          />

          {/* Privacy Text */}
          <p
            style={{
              fontSize: "12px",
              color: "#999",
              marginTop: "15px",
            }}
          >
            We promise not to disclose your personal information to third
            parties.
          </p>

          {/* Button */}
         <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "25px",
  }}
>
  <button
    type="submit"
    style={{
      background: "#f5a000",
      border: "none",
      borderRadius: "40px",
      padding: "8px 8px 8px 30px",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      fontWeight: 600,
      fontSize: "16px",
      cursor: "pointer",
    }}
  >
    <span>Apply</span>

    <span
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        background: "#000",
        color: "#f5a000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: 700,
      }}
    >
      →
    </span>
  </button>
</div> 
        </form>
      </div>
    </section>
    <Footer/>
    </>
  );
};

export default ApplyJob;